import { useFeatureFlag } from '@/modules/featureFlags/useFeatureFlag';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';

/**
 * Returns the paths of the memo list and memo details pages. When
 * `memos_in_studio` is enabled, memos live under the Studio. Otherwise, they
 * live under the household Documents page.
 */
export function useMemoPaths(householdId: string) {
  const isMemosInStudioEnabled = useFeatureFlag('memos_in_studio');

  return {
    memoListPath: getCompletePathFromRouteKey(
      isMemosInStudioEnabled
        ? ROUTE_KEYS.HOUSEHOLD_ARTIFACT_BUILDER
        : ROUTE_KEYS.HOUSEHOLD_DETAILS_DOCUMENTS_MEMOS,
      { householdId }
    ),
    getMemoDetailsPath: (memoId: string) =>
      getCompletePathFromRouteKey(
        isMemosInStudioEnabled
          ? ROUTE_KEYS.HOUSEHOLD_ARTIFACT_BUILDER_MEMO_DETAILS
          : ROUTE_KEYS.HOUSEHOLD_DETAILS_MEMO_DETAILS,
        { householdId, memoId }
      ),
  };
}
